import React, { useState, useEffect, useCallback } from 'react';
import { END_URL } from "../../config";
import '../PastResults/PersonalityResultHistory.css';
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight,faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import loadimg from "../../images/loader_wish.gif";

function DilemmaPasts({ onLoginChange, userdetail }) {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [RetakeLabel, setRetakeLabel] = useState("Retake Test");

  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const { slug } = useParams();

  const fetchUserResult = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${END_URL}/user-dilemma-result/${slug}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      const mapped = (data?.dilemma_results || []).map(item => ({
        id: item.id,
        slug: item.slug,
        result: item.result,
        dilemmaName: item.dilemma?.name || item.result || "Unknown",
        testDate: item.created_at,
        test_link:item?.test_link,
        subscriptionId: item.subcription_id,
      }));

      setResults(mapped);

      setRetakeLabel(data?.test?.testdetail?.re_take_test_label || "Retake Test");

    } catch (error) {
      console.error("Error fetching result:", error);
    } finally {
      setIsLoading(false);
    }
  }, [token, slug]);

  useEffect(() => {
    fetchUserResult();
  }, [fetchUserResult]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day   = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year  = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const handleDeleteClick = (id) => setConfirmDeleteId(id);

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${END_URL}/test-result/${confirmDeleteId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Failed to delete");
      setResults(prev => prev.filter(r => r.id !== confirmDeleteId));
      setConfirmDeleteId(null);
    } catch (error) {
      console.error("Error deleting result:", error);
    }
  };

  const ConfirmModal = ({ message, onConfirm, onCancel }) => (
    <div className="modal-question history-modal">
      <div className="modal-test">
        <div className="modal-content-test">
          <div className="modal-dymic">{message}</div>
          <button className="modal-close-button-test" onClick={onConfirm}>Yes</button>
          <button className="modal-close-button-test" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="personality-result-history">
      <main className="main-content">
        {isLoading ? (
          <div className="loader-container">
            <img src={loadimg} alt="Loading..." className="loader-gif" />
          </div>
        ) : (
          <div className="container">
            <div className="content-section">

              <button className="retake-test-btn back-button" onClick={() => navigate(-1)}>
                <span><FontAwesomeIcon icon={faArrowLeft} /></span>
                <span>Back</span>
              </button> 

              <h1 className="page-title">Result History</h1>

              <div className="table-container">
                <table className="results-table">
                  <thead>
                    <tr>
                      <th>Personality Type</th>
                      <th>Test Taken</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map(result => (
                      <tr key={result.id} className="result-row">
                        <td className="personality-type-cell">
                          <span
                            className="personality-type-link"
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate(`/${result?.test_link}`)}
                          >
                            {result.dilemmaName} ({result.result})
                          </span>
                        </td>
                        <td className="date-cell">
                          {formatDate(result.testDate)}
                        </td>
                        <td className="actions-cell">
                          <div className="action-buttons">
                            <button
                              className="action-btn delete-btn"
                              onClick={() => handleDeleteClick(result.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {confirmDeleteId && (
                <ConfirmModal
                  message="Are you sure you want to delete this test result?"
                  onConfirm={confirmDelete}
                  onCancel={() => setConfirmDeleteId(null)}
                />
              )}

              <div className="retake-test-section">
                <button
                  className="retake-test-btn"
                  onClick={() => { window.location.href = `/dilemma/${slug}`; }}
                >
                  {RetakeLabel}
                  <span>
                    <FontAwesomeIcon className="icc" icon={faArrowRight} />
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default DilemmaPasts;